import { Country } from '@nkr/enums/country';
import { IFollowUpSurvey } from '@nkr/models/follow-up';
import { Panel } from 'react-bootstrap';

const DonorDetails = (props: { data: IFollowUpSurvey }) => {
    let state = props.data.countryId == Country.UnitedStates ? props.data.state : props.data.nonUsStateProvince;

    return (
        <Panel>
            <Panel.Heading>Donors Details</Panel.Heading>
            <Panel.Body>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>Name:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.fullName}</div>
                    <div className='col-xs-6 col-sm-2'><strong>Email:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.email}</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>Address:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.addressLine1}</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>City, State:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.city}, {state ?? '[not answered]'}</div>
                    <div className='col-xs-6 col-sm-2'><strong>Postal Code:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.postalCode}</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>Phone Number:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.phone}</div>
                    <div className='col-xs-6 col-sm-2'><strong>Country:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.country}</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>Birthdate:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.birthDate}</div>
                    <div className='col-xs-6 col-sm-2'><strong>Donation Date:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.donationDate}</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>Height:</strong></div>
                    <div className='col-xs-6 col-sm-4'>
                        {props.data.heightInches != null && (
                            <>{Math.floor(props.data.heightInches / 12)}' {props.data.heightInches % 12}"</>
                        )}
                    </div>
                    <div className='col-xs-6 col-sm-2'><strong>Weight:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.weightLbs} lbs.</div>
                </div>
                <div className='row'>
                    <div className='col-xs-6 col-sm-2'><strong>BMI:</strong></div>
                    <div className='col-xs-6 col-sm-4'>{props.data.bmi != null ? props.data.bmi : '--'}</div>
                </div>
            </Panel.Body>
        </Panel>
    )
}

export default DonorDetails;